import { useState } from "react";
import { useAnalytics } from "@commons-monorepo/index";
import { TemplateType } from "@commons-monorepo/index";
import { Review } from "../../components/Review/Review";
import { REVIEW_EVENTS } from "../../reviews.events";
import { useLogicReviews } from "../../reviews.hook";
import { ReviewsProps } from "../../reviews.types";
import styles from "./reviews-skin-2.module.css";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "@remix-run/react";

export const ReviewsSkin2 = ({ reviews, source, name }: ReviewsProps) => {
  const { t } = useTranslation();
  const { storeMetadata } = useOutletContext<any>();
  const [logEvent] = useAnalytics({ storeMetadata });
  const { reviewsState } = useLogicReviews({ reviews, source, name });
  const [showAllItems, setShowAllItems] = useState(false);

  const handleToggleAll = () => {
    setShowAllItems(!showAllItems);
    logEvent(REVIEW_EVENTS.SELECT_STORE_REVIEWS);
  };

  return (
    <div className={`${styles.reviewsSkin2Styled}`}>
      <div
        className={`${styles.reviewsList} ${
        reviewsState.length <= 3 ? styles.reviewsList__simple : ""
        }`}>

        {reviewsState.
        slice(0, showAllItems ? undefined : 3).
        map((review, index) =>
        <div
          className={`${styles.reviewBox}`}
          key={`${index}-${review.stars}-${review.scoreDate}`}>

              <Review
            review={review}
            skin={TemplateType.PRODUCT_REVIEWS_SKIN_2} />

            </div>
        )}
      </div>
      {reviewsState.length > 3 &&
      <div className={`${styles.reviewsFooter}`}>
          <button
          className={`${styles.reviewsFooterButton}`}
          onClick={handleToggleAll}>

            {showAllItems ? (
          t("reviews.hide_all") as any) :
          t("reviews.show_all")}
          </button>
        </div>}

    </div>);

};